// extracted by mini-css-extract-plugin
module.exports = {"container":"order-search-view__container___d0yj1","toolbar":"order-search-view__toolbar___3_WyZ","content":"order-search-view__content___3Yfwf"};